<template>
  <div
    :data-balloon="displayName"
    data-balloon-pos="right"
    class="avatar inline-flex cursor-auto [&+_.avatar]:-ml-1"
    :data-test="`producer-avatar-${displayName}`"
  >
    <img
      :src="profileImageUrl"
      :alt="`Profile image of ${displayName}`"
      class="h-[28px] w-[28px] rounded-full border-2 border-solid border-current"
      @error="$event.target.src=defaultAvatar"
    />
  </div>
</template>

<script>

export default {
  name: 'TgbAvatar',
  props: {
    displayName: String,
    profileImageUrl: String,
    borderColor: String,
    defaultAvatar: {
      type: String,
      default: './producer/assets/img/profile_placeholder.png',
    },
  },
};
</script>
